import i18next from 'i18next';
import * as React from 'react';
import { List } from 'immutable'
import { StandardLocalWidget, any, async, fromJSX, wait, nothing } from "widgets-for-react";
import { TextPageHeader } from '../../site/root/pageHeader/pageHeaderLayout';
import { routeUpdaters } from '../../site/root/routes/routesState';
import { FormControls, AuthButtonPrimary, AuthButtonSecondary } from "../../utils/forms";
import { BreadcrumbItem } from '../../utils/breadcrumbs'
import { singleValidatorResultBuilders } from "../../validator/validator";
import { StopSubscriptionState, stopSubscriptionUpdaters } from "./stopSubscriptionState";
import { getLastSegment } from '../../utils/breadcrumbs'
import { RootLayout } from '../../site/root/rootLayout';

const breadcrumbs = () =>
  List([
    {
      url: routeUpdaters(i18next.language).dashboard.url,
      label: getLastSegment(routeUpdaters(i18next.language).dashboard.url),
    },
    {
      url: routeUpdaters(i18next.language).accountDetails.url,
      label: getLastSegment(routeUpdaters(i18next.language).accountDetails.url),
    },
    {
      url: routeUpdaters(i18next.language).subscriptionStopPayment.url,
      label: getLastSegment(routeUpdaters(i18next.language).subscriptionStopPayment.url),
    },
  ])

export const stopSubscriptionWidget: StandardLocalWidget<StopSubscriptionState> = currentState =>
  any([
    async(currentState.subscriptionToStop).map(stopSubscriptionUpdaters.subscriptionToStopLoaded), // We need this to update the widget/page state when the subscriptionToStop asyncState changes
    async(currentState.stopSubscription).map(stopSubscriptionUpdaters.stopSubscriptionFinished), // We need this to update the widget/page state when the stopSubscription asyncState changes
    currentState.asyncsWorkingDisableInput() ?
      fromJSX(() => <RootLayout.Loader showText hasWrapper />)
    : currentState.asyncsFailed() ? fromJSX(() => <RootLayout.Error />) // Show error message when retrieving the subscriptions failed for some reason
    : currentState.stopSubscription.kind == "loaded" ?
      fromJSX(() =>
        currentState.stopSubscription.kind == "loaded" ?
          <StopSubscriptionLayout.ThankYou
            breadcrumbs={breadcrumbs()}
          />
          : <></>
      )
      : fromJSX(setState => (
        <div className="text-screen">
          <TextPageHeader
            title={i18next.t('subscription:StopCurrentSubscription')}
            intro={i18next.t('subscription:StopCurrentSubscriptionIntro')}
            breadcrumbs={breadcrumbs()}
            additionalJSX={
              <>
                <FormControls.FormCheckInGroup
                  controlId="subscriptionConfirmStop"
                  label={i18next.t("subscription:StopSubscriptionConfirmation")}
                  required={true}
                  checked={currentState.areYouSure || false}
                  onChange={(newValue => setState(stopSubscriptionUpdaters.areYouSure(_ => newValue)))}
                  validation={currentState.areYouSure == false
                    ? singleValidatorResultBuilders.failed("confirmStop", i18next.t('subscription:StopSubscriptionError'))
                    : singleValidatorResultBuilders.passed("confirmStop")}
                />
              </>
            }
          />
          <section className="block block--text">
            <div className="block__inner container--m gutter--m">
              <div className="block__footer block__clickables">
                <div className="block__clickable">
                <AuthButtonSecondary
                    kind="link"
                    to={routeUpdaters(i18next.language).accountDetails.url}
                    disabled={false}
                    label={i18next.t('subscription:Back')}
                  />
                </div>
                <div className="block__clickable">
                  
                  <AuthButtonPrimary
                    kind="button"
                    type="button"
                    disabled={!currentState.isValid()}
                    onClick={(e) => setState(stopSubscriptionUpdaters.invokeStopSubscriptionApi)}
                    label={i18next.t("subscription:StopSubscription")}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      ))
  ])

export const StopSubscriptionLayout = {
  // This is a partial that was removed from SubscriptionLayout.Thankyou 
  // because the 'stop subscription' variant was an already quite different case
  // and we needed to reduce the required state type to 'StopSubscriptionState' instead of the higher level 'SubscriptionState'
  // as the 'SubscriptionState' was only really used to distinguish between the variant required
  ThankYou: (props: {
    buttonLabel?: string
    breadcrumbs?: List<BreadcrumbItem>
  }) => {
    let Title = i18next.t('subscription:SubscriptionStoppedThankYouTitle')
    let Message = i18next.t('subscription:SubscriptionStoppedThankYouMessage')
    let Button = i18next.t('paywall:paywallSubscribeButton')

    return (
      <div className="text-screen">
        <TextPageHeader
          title={Title || i18next.t('subscription:ThankYou')}
          intro={Message || undefined}
          breadcrumbs={props.breadcrumbs || undefined}
          additionalJSX={
            <div className="block__clickables">
              <div className="block__clickable">
                <AuthButtonPrimary
                  kind="link"
                  to={routeUpdaters(i18next.language).accountDetails.url}
                  label={
                    Button ||
                    props.buttonLabel ||
                    i18next.t('subscription:BackToSubscriptions')
                  }
                  disabled={false}
                />
              </div>
            </div>
          }
        />
      </div>
    )
  }
}